.wrap {
  height: 400vh;
  height: 400svh;
  height: var(--scrub-track-height, 400svh);
  position: relative;
  background: var(--film-bg);
}
.sticky {
  position: sticky;
  top: 0;
  height: 100vh;
  height: 100svh;
  height: 100dvh;
  overflow: hidden;
}
.video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: var(--film-bg);
  filter: brightness(1.02) contrast(0.93) saturate(0.97);
}
.toneWash {
  position: absolute;
  inset: 0;
  background: #d8dfe6;
  opacity: 0.2;
  pointer-events: none;
}
.blur {
  position: absolute;
  inset: 0;
  background: rgba(12, 9, 7, 0.3);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  pointer-events: none;
}
.badge {
  position: absolute;
  top: 16px;
  left: 16px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  padding: 5px 14px;
  font-family: var(--font-label);
  font-size: 10.5px;
  letter-spacing: 3px;
  color: rgba(255, 255, 255, 0.7);
}
.contentLayer {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
}
.radial {
  position: absolute;
  left: 0;
  right: 0;
  top: 60%;
  transform: translateY(-50%);
  height: 78vh;
  height: 78svh;
  height: calc(var(--scrub-viewport-height, 100svh) * 0.78);
  background: radial-gradient(
    ellipse 62% 50% at 50% 50%,
    rgba(10, 8, 6, 0.5) 0%,
    rgba(10, 8, 6, 0.28) 48%,
    rgba(10, 8, 6, 0) 74%
  );
  pointer-events: none;
}
.box {
  margin-top: 48vh;
  margin-top: 48svh;
  margin-top: calc(var(--scrub-viewport-height, 100svh) * 0.48);
  font-family: var(--font-griun);
  text-align: center;
  position: relative;
  text-shadow: 0 1px 3px rgba(10, 8, 6, 0.55), 0 3px 14px rgba(10, 8, 6, 0.45);
  /* 스크럽 콜백이 아직 한 번도 못 돌았을 때(섹션이 화면 밖) 기본값으로 보이면
     안 된다 — HeroFilm의 .t2와 같은 이유로 정지 상태를 0으로 못박는다. */
  opacity: 0;
}
.caption {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink-film);
}
.subCaption {
  font-size: 12.5px;
  line-height: normal;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 4px;
  text-indent: 4px;
  margin-top: 10px;
}
.digits {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 24px;
}
.digitCol {
  text-align: center;
}
.flipBox {
  position: relative;
  width: 62px;
  height: 76px;
  perspective: 340px;
  overflow: hidden;
  mask-image: linear-gradient(180deg, transparent 0, #000 24%, #000 76%, transparent 100%);
  -webkit-mask-image: linear-gradient(180deg, transparent 0, #000 24%, #000 76%, transparent 100%);
}
.strip {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  will-change: transform;
}
.cell {
  height: 76px;
  line-height: 76px;
  text-align: center;
  font-family: var(--font-label);
  font-weight: 700;
  font-size: 34px;
  color: #f3f6f9;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(10, 8, 6, 0.45), 0 3px 10px rgba(10, 8, 6, 0.35);
}
.flipLabel {
  margin-top: 8px;
  font-family: var(--font-label);
  font-size: 9px;
  letter-spacing: 3px;
  text-indent: 3px;
  color: rgba(255, 255, 255, 0.65);
}
.scrollGuide {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  height: 78px;
  display: grid;
  place-items: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.4s ease;
}
.scrollGuide[data-active='true'] {
  opacity: 1;
}
.guideHand {
  width: 30px;
  height: 42px;
  overflow: visible;
  fill: rgba(248, 241, 231, 0.07);
  stroke: rgba(255, 250, 244, 0.94);
  stroke-width: 1.35;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter:
    drop-shadow(0 1px 2px rgba(10, 8, 6, 0.82))
    drop-shadow(0 3px 6px rgba(10, 8, 6, 0.52));
  animation: endingScrollMotion 2.4s ease-in-out infinite;
  animation-play-state: paused;
}
.scrollGuide[data-active='true'] .guideHand {
  animation-play-state: running;
}
@keyframes endingScrollMotion {
  0%, 100% { transform: translateY(12px); }
  50% { transform: translateY(-12px); }
}
@media (max-height: 600px) {
  .scrollGuide {
    bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    height: 60px;
  }
  .guideHand {
    width: 24px;
    height: 32px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .guideHand {
    animation: none;
    transform: none;
  }
}
/* 낮은 가로 화면에서는 기존 중앙 카운트다운을 가리지 않도록 옆으로 비킨다. */
@media (max-height: 480px) and (orientation: landscape) {
  .scrollGuide {
    left: auto;
    right: 12px;
    width: 48px;
  }
}
